import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Card, CardContent, Grid, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '1.5rem',
  width: '100%',
  gap: '1.5rem',
}));

export const GridStyled = styled(Grid)(() => ({
  width: '100%',
  flexGrow: 1,
}));

export const CardContentMain = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  justifyContent: 'space-between',
  width: '-webkit-fill-available',
  padding: 0,
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  justifyContent: 'center',

  [theme.breakpoints.up('sm')]: {
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
}));

export const DownIcon = styled(KeyboardArrowDownIcon)(() => ({
  width: '2.5rem',
  height: '2.5rem',
  border: `1px solid ${theme.palette.secondary.dark}`,
  borderRadius: '0.5rem',
  color: theme.palette.common.white,
}));

export const UpIcon = styled(KeyboardArrowUpIcon)(() => ({
  width: '2.5rem',
  height: '2.5rem',
  border: `1px solid ${theme.palette.secondary.dark}`,
  borderRadius: '0.5rem',
  color: theme.palette.common.white,
}));

export const DatePickerContainer = styled('div')(() => ({
  display: ' flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));
